import FooterDownloads from "components/FooterDownloads";
import FooterLinks from "components/FooterLinks";
import React from "react";

interface FooterProps {
    shouldShowDownloads?: boolean;
    footerHeading?: string;
    footerSubheading?: string;
    localised?: boolean;
    language?: string;
    isPageAuth?: boolean;
    isPagePhotosIndex?: boolean;
}

const Footer: React.FC<FooterProps> = ({
    shouldShowDownloads,
    footerHeading,
    footerSubheading,
    localised,
    language,
    isPageAuth,
    isPagePhotosIndex,
}) => {
    return (
        <footer>
            {shouldShowDownloads ? (
                <FooterDownloads
                    footerHeading={footerHeading}
                    footerSubheading={footerSubheading}
                />
            ) : (
                <></>
            )}
            <FooterLinks
                localised={localised}
                language={language}
                isPageAuth={isPageAuth}
                isPagePhotosIndex={isPagePhotosIndex}
            />
        </footer>
    );
};

export default Footer;
